import React from 'react';
import Hero from './Hero';
import About from './About';
import Experience from './Experience';
import Skills from './Skills';
import Contact from './Contact';

const HomePage: React.FC = () => {
  return (
    <div className="mx-auto max-w-3xl md:border-x">
      <Hero />
      <About />
      <Experience />
      <Skills />
      <Contact />
    </div>
  );
};

export default HomePage;